// Feature flights.
//
// Flip a default here to ship. To preview a flight without changing code,
// add it to the URL, e.g. https://your-site/?enableOct2026Design=1
// (use =0 to force it off). The override is remembered for the browser tab.

const DEFAULTS = {
  // Oct 2026 redesign (static pages in public/oct2026/): landing + the hand,
  // paintings, photos and the index. Off = the current design.
  enableOct2026Design: true,
};

function readOverride(name) {
  try {
    const param = new URLSearchParams(window.location.search).get(name);
    if (param === "1" || param === "true") {
      sessionStorage.setItem(`flight:${name}`, "1");
    } else if (param === "0" || param === "false") {
      sessionStorage.setItem(`flight:${name}`, "0");
    }
    const stored = sessionStorage.getItem(`flight:${name}`);
    if (stored === "1") return true;
    if (stored === "0") return false;
  } catch {
    // storage can be unavailable (private mode, sandboxed frames); fall through
  }
  return undefined;
}

export function isFlightOn(name) {
  const override = readOverride(name);
  return override !== undefined ? override : Boolean(DEFAULTS[name]);
}

export const flights = Object.fromEntries(
  Object.keys(DEFAULTS).map((name) => [name, isFlightOn(name)])
);
